export default {
    init() {
        document.addEventListener('DOMContentLoaded', function () {
            const modal = document.getElementById('customModal');
            const closeModalButton = document.getElementById('closeModalButton');
            const contentPreview = document.querySelector('.content-preview');
            const urlParams = new URLSearchParams(window.location.search); // Parse URL parameters
            const isSoftEnabled = urlParams.get('soft') === 'true'; // Check if "soft" parameter is true
            let modalTriggered = false;

            // Define the modal functions outside the conditional block
            const openModal = () => {
                modal.classList.remove('hidden');
                //   document.body.style.overflow = 'hidden';
            };

            const closeModal = () => {
                modal.classList.add('hidden');
                //   document.body.style.overflow = '';
            };

            // if "soft" parameter is true
            if (isSoftEnabled) {
                // Add the 'soft-enabled' class to content-preview
                if (contentPreview) {
                    contentPreview.classList.add('soft-enabled');
                }

                // Trigger modal when scrolling past content preview
                window.addEventListener('scroll', function () {
                    if (modalTriggered) return; // Prevent modal from triggering multiple times

                    if (contentPreview) {
                        const rect = contentPreview.getBoundingClientRect();
                        const scrollPosition = window.scrollY + window.innerHeight;

                        // Check if the user has scrolled past the content preview
                        const contentBeyondVisible = scrollPosition > (window.scrollY + rect.top + rect.height);

                        if (contentBeyondVisible) {
                            openModal(); // Trigger the modal
                            modalTriggered = true; // Modal triggered flag
                        }
                    }
                });

                // Close modal when the close button is clicked
                if (closeModalButton) {
                    closeModalButton.addEventListener('click', closeModal);
                }
            }
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/single.js